import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { JSONRpc } from './service-jsonrpc';
import { Observable, of, observable, Subject, BehaviorSubject, ReplaySubject } from 'rxjs';

import { environment } from '../../environments/environment';

import * as _ from 'lodash';
import { FormulaireComponent } from '../views/pages/formulaire/formulaire.component';
@Injectable({
  providedIn: 'root'
})
export class DroitsService {
    constructor(
        private http: HttpClient
        )
    {}

    getDroitsForInstruction(instructionid:any, options:any): Observable<any>{
        let rpcMethod = new JSONRpc({
            jsonrpc : "2.0",
            method:"webservice.instruction:droits",
            params: {
              id: instructionid,
              application: "GESTMAT",
              options: options
            }
          });
          return this.http.post<JSONRpc>(environment.webservice, rpcMethod);
    }
    checkDroitsInstructionRead(instruction:any, droit:any){

    }
    checkDroitsInstructionUnique(instruction:any, listInstruction:any, droit:any){

    }
    checkDroitsInstructionWrite(instruction:any, droit:any){

    }

    checkDroitsDemandeRead(demande:any, droit:any){

    }
    checkDroitsDemandeUnique(demande:any, droit:any){

    }
    checkDroitsDemandeWrite(demande:any, droit:any){

    }

    checkDroitsEtapeRead(etape:any, droit:any){

    }
    checkDroitsEtapeUnique(etape:any, droit:any){

    }
    checkDroitsEtapeWrite(etape:any, droit:any){

    }

    checkDroitsFormulaireCreate(formulaire:any, droit: any){
      if(droit.FORMULAIRES[formulaire.key] && !droit.FORMULAIRES[formulaire.key].c)
        return false;
      else
        return true;
    }
    checkDroitsFormulaireRead(formulaire:any, droit: any){
      if(droit && droit.FORMULAIRES[formulaire.form.key] && !droit.FORMULAIRES[formulaire.form.key].r)
        return false;
      else
        return true;
    }
    checkDroitsFormulaireUnique(formulaire:any, droit: any){
      if(droit.FORMULAIRES[formulaire.key] && droit.FORMULAIRES[formulaire.key].u && droit.DEMANDE_FORMULAIRE_COUNT[formulaire.key])
        return true;
    }
    checkDroitsFormulaireWrite(formulaire:any, droit: any){
      if(droit.FORMULAIRES[formulaire.key] && !droit.FORMULAIRES[formulaire.key].w)
        return false;
      else
        return true;
    }

    checkDroitsDocumentCreate(document:any, droit: any){
      if(droit.DOCUMENTS[document.document.type.key] && !droit.DOCUMENTS[document.document.type.key].c)
        return false;
      else
        return true;
    }
    checkDroitsDocumentRead(document:any, droit:any){
      if(droit && droit.DOCUMENTS[document.document.type.key] && !droit.DOCUMENTS[document.document.type.key].r)
        return false;
      else
        return true;
    }
    checkDroitsDocumentUnique(document:any, droit:any){
      if(droit.DOCUMENTS[document.document.type.key] && droit.DOCUMENTS[document.document.type.key].u && droit.DEMANDE_DOCUMENT_COUNT[document.document.type.key])
        return true;
    }
    checkDroitsDocumentWrite(document:any, droit:any){
      if(droit.DOCUMENTS[document.document.type.key] && !droit.DOCUMENTS[document.document.type.key].w)
        return false;
      else
        return true;

    }

    checkDroitsRDVCreate(rdv:any, droit:any){
      if(droit.FORMULAIRES[rdv.key] && rdv.type === 1 && !droit.FORMULAIRES[rdv.key].c)
        return false;
      else
        return true;
    }
    checkDroitsRDVRead(rdv:any, droit:any){

      if(droit && droit.FORMULAIRES[rdv.form.key] && rdv.form.type === 1 && !droit.FORMULAIRES[rdv.form.key].r)
        return false;
      else
        return true;
    }
    checkDroitsRDVUnique(rdv:any, droit:any){
      if(droit.FORMULAIRES[rdv.key] && rdv.type === 1 && !droit.FORMULAIRES[rdv.key].w)
        return false;
      else
        return true;
    }
    checkDroitsRDVWrite(rdv:any, droit:any){
      if(droit.FORMULAIRES[rdv.key] && rdv.type === 1 && !droit.FORMULAIRES[rdv.key].w)
        return false;
      else
        return true;
    }

    checkDroitsCourrierCreate(courrier:any, droit:any){
      if(droit.COURRIERS[courrier.key] && !droit.COURRIERS[courrier.key].c)
        return false;
      else
        return true;
    }
    checkDroitsCourrierRead(courrier:any, droit:any){
      if(droit && droit.COURRIERS[courrier.courrier.key] && !droit.COURRIERS[courrier.courrier.key].r)
        return false;
      else
        return true;
    }
    checkDroitsCourrierUnique(courrier:any, droit:any){
      if(droit.COURRIERS[courrier.key] && droit.COURRIERS[courrier.key].u && droit.DEMANDE_COURRIER_COUNT[courrier.key])
        return true;
    }
    checkDroitsCourrierWrite(courrier:any, droit:any){
      if(droit.COURRIERS[courrier.courrier.key] && !droit.COURRIERS[courrier.courrier.key].w)
        return false;
      else
        return true;
    }

    checkDroitExport(user: any, droits: Array<string | [string, boolean]>) {
      let hasPermission = true

      if (!droits || !user || !user.droits) return hasPermission
      
      const userDroit = Object.keys(user.droits)

      for (const droit of droits) {
        const droitName = typeof droit === "string" ? droit : droit[0]
        const droitOverwrite = typeof droit === "string" ? false : droit[1]

        if (userDroit.includes(droitName)) {

          if (hasPermission) hasPermission = user.droits[droitName].r

          if (droitOverwrite) return user.droits[droitName].r
        }
      }

      return hasPermission
    }

    checkDroitDocument(user: any, droit: string) {
      let hasPermission = true

      if (!droit || !user || !user.rights || !user.rights.document) return hasPermission
      
      const userDroits = Object.keys(user.rights.document)

      for (const userDroit of userDroits) {
        const userRights = user.rights.document[userDroit]
        const droitDocument = userRights.objets.document

        const hasLibelle = droitDocument.find(doc => doc.objet.libelle === droit)

        if (hasLibelle && hasPermission) hasPermission = userRights.r
      }

      return hasPermission
    }
}